import React, {Component} from 'react'
import FJNameInput from "./FJNameInput";
import classNames from 'classnames'

class FJIntroLabelInput extends Component {

  /**
   * @description 判断是否为空字符串
   * @return {boolean}
   */
  inNone = () => {
    return this.props.value === ''
  };

  /**
   * @description 显示错误提示的动画
   */
  showErrorAnimation = () => {
    this.input.errorAnimation();
  };

  render() {
    let {inputPaddingLeft, inputWidth, hasError, value, errorValue, placeholder, title, isRequired} = this.props;
    const {onChange, onSubmit} = this.props;
    return (
      <div className='c-export-option-name c-export-video-name'>
        <label className={classNames('c-export-label c-export_intro-title', {'c-export_intro-video-title': isRequired})}>{title}</label>
        <FJNameInput style={{paddingLeft: inputPaddingLeft, width: inputWidth}}
                     ref={ele => this.input = ele}
                     errorValue={errorValue}
                     hasError={hasError}
                     onSubmit={onSubmit}
                     onChange={onChange}
                     placeholder={placeholder}
                     value={value}
        />

      </div>
    );
  }
}

export default FJIntroLabelInput;